module.exports = __webpack_public_path__ + "static/babyscan1-950f197222cfc90311729c2fc7babcfb.jpeg";